import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionIndExp = (props) => {
  return (
    <Hoc>
      <CvItem date1="Jul 2014" date2="Sep 2016" imgSrc="Dynamic space.png">
        <CvItemDesc descBold="Fazaye Pouya" descNormal="Tehran, Iran" descComment="" />
        <CvItemDetail primary bold>
          Collaborator
        </CvItemDetail>
      </CvItem>

      <CvItem date="2017">
        <CvItemDesc descNormal="Study Abroad Seminars 2017 (Collaborator)" />
      </CvItem>

      <CvItem date="2014">
        <CvItemDesc descNormal="Eco Tehran’ Seminar & Workshop 2014 (Contributor and workshop assistance)" />
      </CvItem>
    </Hoc>
  );
};

export default cvSectionIndExp;
